import React, { useState, useEffect } from "react";
import practiceTeamData from "../practiceTeam.json";
import "./PracticeTeam.css";

const PracticeTeam = () => {
  const [practiceTeam, setPracticeTeam] = useState(practiceTeamData);

  // Optionally load from external JSON file at runtime
  useEffect(() => {
    // If you want to load from a public JSON file instead, uncomment below:
    // fetch('/practiceTeam.json')
    //   .then(res => res.json())
    //   .then(data => setPracticeTeam(data))
    //   .catch(err => console.error('Error loading practice team data:', err));
  }, []);

  return (
    <main>
      <div className="mainBody">
        {/* Banner Section */}
        <div className="bannerBlock1">
          <div
            style={{
              position: "absolute",
              right: "0px",
              width: "250px",
              height: "155px",
              backgroundImage: "url(images/globe.png)",
              backgroundPosition: "-0px -40px",
            }}
          ></div>
          <div className="bannerContent">
            <div className="content">
              <span className="pageTitle">PRACTICE TEAM</span>
              <br />
              <span className="subTitle">
                Meet the experts driving innovation and delivering exceptional results
              </span>
            </div>
          </div>
        </div>

        {/* Professionals Section */}
        <div className="content padSmall">
          <h2 className="sectionTitle">Our Practice Team</h2>
          <div className="professionalsGrid">
            {practiceTeam.professionals.map((professional, index) => (
              <div key={index} className="professionalCard">
                <div className="professionalHeader">
                  {professional.image ? (
                    <div className="professionalImage">
                      <img src={professional.image} alt={professional.name} />
                    </div>
                  ) : (
                    <div className="professionalImagePlaceholder">
                      <span className="initials">
                        {professional.name
                          .split(" ")
                          .map((n) => n[0])
                          .join("")}
                      </span>
                    </div>
                  )}
                  <div className="professionalInfo">
                    <h3 className="professionalName">{professional.name}</h3>
                    <p className="professionalTitle">{professional.title}</p>
                  </div>
                </div>
                <div className="professionalBio">
                  <p>{professional.bio}</p>
                </div>
                {professional.expertise && professional.expertise.length > 0 && (
                  <div className="professionalExpertise">
                    <span className="expertiseLabel">Expertise:</span>
                    <div className="expertiseTags">
                      {professional.expertise.map((skill, skillIndex) => (
                        <span key={skillIndex} className="expertiseTag">
                          {skill}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
                {professional.email && (
                  <div className="professionalContact">
                    <a href={`mailto:${professional.email}`} className="contactLink">
                      Contact {professional.name.split(" ")[0]}
                    </a>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
      <div style={{ clear: "both" }}></div>
    </main>
  );
};

export default PracticeTeam;

